import { getOddsValue, parseExprCombStr } from "./common";

export const parseFullOdds = (pmPool, message) => {
    if(message != null){
        if(message.updAt != null && message.cmb !=null){
            pmPool.lastUpdateTime = message.updAt;
            pmPool.oddsLastUpdateTime = message.updAt;
            message.cmb.forEach(comb => {
                let isCwin = ["CWA", "CWB", "CWC"].includes(pmPool.oddsType);
                let targetComb = pmPool.oddsNodes.find(x=> {
                    let combStr = isCwin ? x.combString.substring(1) : x.combString;
                    return combStr===comb.cmbStr
                });
                if ( targetComb!=null ) {
                    targetComb.oddsValue = getOddsValue(comb.odds, comb.cmbSt);
                    targetComb.hotFavourite = comb.hf===true;
                    targetComb.oddsDropValue = parseInt(comb.oDrp) || 0;
                }else{
                    pmPool.oddsNodes.push({
                        oddsValue :getOddsValue(comb.odds, comb.cmbSt),
                        hotFavourite : comb.hf===true,
                        oddsDropValue : parseInt(comb.oDrp) || 0,
                        combString: comb.cmbStr
                    })
                }
            });
        }
    }
}

export const parseExpressFullOdds = (pmPool, message) => {
    if(message != null){
        if(message.updAt != null && message.cbs !=null){
            pmPool.lastUpdateTime = message.updAt;
            pmPool.oddsLastUpdateTime = message.updAt;
            message.cbs.forEach(comb => {
                let isCwin = ["CWA", "CWB", "CWC"].includes(pmPool.oddsType);
                let curCombStr = parseExprCombStr(comb.cb)
                let targetComb = pmPool.oddsNodes.find(x=> {
                    let combStr = isCwin ? x.combString.substring(1) : x.combString;
                    
                    return combStr === curCombStr
                });
                const oddsDropValue = comb.chg >= 0 ? 0 : Math.abs(comb.chg)
                if ( targetComb!=null ) {
                    targetComb.oddsValue = getOddsValue(comb.ods, comb.st);
                    targetComb.hotFavourite = comb.hF == '1';
                    targetComb.oddsDropValue = oddsDropValue || 0;
                }else{
                    pmPool.oddsNodes.push({
                        oddsValue :getOddsValue(comb.ods, comb.st),
                        hotFavourite : comb.hF == '1',
                        oddsDropValue : oddsDropValue || 0,
                        combString: curCombStr
                    })
                }
            });
        }
    }
}

export const parseLast2Mins = (pmPool, message) => {
    let snapshotData = message?.oddsSnapshot?.slide2m || message?.oddsSnapshot?.last2Min
    if(snapshotData != null){
        if(snapshotData.updAt != null && snapshotData.cmb!=null){
            pmPool.lastUpdateTime = snapshotData.updAt;
            pmPool.oddsLastUpdateTime = snapshotData.updAt;
            snapshotData.cmb.forEach(comb => {
                let targetComb = pmPool.oddsNodes.filter(x=> {
                    let combStr = x.combString;
                    return combStr===comb.cmbStr
                })[0];
                if ( targetComb!=null ) {
                    targetComb.oddsValue = getOddsValue(comb.odds, comb.cmbSt);
                }
            });
        }
    }
}

export const parseFirstNamed = (pmPool, message) => {
    const snapshotData = message?.oddsSnapshot?.['1stBoost'] || message?.oddsSnapshot?.firstNamed
    if(snapshotData != null){
        if(snapshotData.updAt != null && snapshotData.cmb!=null){
            pmPool.lastUpdateTime = snapshotData.updAt;
            pmPool.oddsLastUpdateTime = snapshotData.updAt;
            snapshotData.cmb.forEach(comb => {
                let targetComb = pmPool.oddsNodes.filter(x=> {
                    let combStr = x.combString;
                    return combStr===comb.cmbStr
                })[0];
                if ( targetComb!=null ) {
                    targetComb.oddsValue = getOddsValue(comb.odds, comb.cmbSt);
                }
            });
        }
    }
}